export const MARKETINGS_RESET_STATE = 'MARKETINGS_RESET_STATE';
export const MARKETINGS_CURRENT_ITEM = 'MARKETINGS_CURRENT_ITEM';

export const MARKETINGS_REQUEST_LOADING = 'MARKETINGS_REQUEST_LOADING';
export const MARKETINGS_REQUEST_SUCCESS = 'MARKETINGS_REQUEST_SUCCESS';
export const MARKETINGS_REQUEST_FAILED = 'MARKETINGS_REQUEST_FAILED';

export const MARKETINGS_CURRENT_ACTION = 'MARKETINGS_CURRENT_ACTION';
export const MARKETINGS_RESET_ACTION = 'MARKETINGS_RESET_ACTION';
